import { CartSummary } from '@/components/modules/_shared/CartSummary/CartSummary';
import { OrderSummary } from '@/components/modules/_shared/OrderSummary/OrderSummary';
import { useCheckoutSessionCart } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSessionCart';
import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { CustomPaper } from '@/components/shared/components/CustomPaper';

export const CheckoutSessionCart = () => {
  const { checkoutSessionEntity, checkoutSession, cartSummaryData, downPayment, discount } =
    useCheckoutSessionCart();

  if (!checkoutSessionEntity || !checkoutSession || !cartSummaryData || !downPayment) {
    return null;
  }

  if (!checkoutSessionEntity.hasCart()) {
    return null;
  }

  return (
    <CustomPaper fill="paper">
      <OrderSummary
        titleTextId="ORDER_DATA"
        checkoutSessionStatus={checkoutSession.status}
        orderReference1={checkoutSession.cart.merchantOrderReference1!}
        orderReference2={checkoutSession.cart.merchantOrderReference2 ?? undefined}
      />
      <CustomDivider margin={2} />
      <CartSummary
        cartSummaryData={cartSummaryData}
        downPayment={downPayment}
        discount={discount}
        checkoutSessionStatus={checkoutSession.status}
      />
    </CustomPaper>
  );
};
